module.exports = __webpack_public_path__ + "static/img/09-北京十一晋元中学1.0f01cce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/09-北京十一晋元中学1.png
// module id = ta2k
// module chunks = 0